<div class="auth-title">
  <h3>{{ 'otp' | translate }}</h3>
  @if(type === 'email') {
    <p>{{ 'verify_email_otp_text' | translate }}</p>
  }
  @if(type === 'number') {
    <p>{{ 'verify_number_otp_text' | translate }}</p>
  }
</div>
<app-alert></app-alert>
<div class="log-in-title">
  <h5>{{ 'otp_code' | translate }}
    @if(type === 'email'){
      <span>{{ email | translate }}</span>
    }
    @if(type === 'number') {
      <p>{{ number.phone }}</p>
    }
  </h5>
</div>
<form class="auth-form-box" [formGroup]="form" (ngSubmit)="submit()">
  <div class="auth-box mb-3 outer-otp">
    <div id="otp" class="inner-otp">
      <input type="text" formControlName="otp" maxlength="5"
              oninput="this.value = this.value?.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              onKeyPress="if(this.value.length==5) return false;" />
    </div>
  </div>
  <app-button [class]="'btn'" [type]="'submit'" [id]="'otp_btn'" [spinner]="true">{{'verify' | translate}}</app-button>
  <a href="javascript:void(0)" class="modal-back" (click)="backForm()">
    <i class="ri-arrow-left-line"></i>
  </a>

</form>
